import { ServiceTypeEnum } from '@enums/service-type.enum';
import { UserRoleEnum } from '@enums/user-role.enum';

export const canShowOrTime = (serviceType: ServiceTypeEnum): boolean => {
  const allowedTypes: ServiceTypeEnum[] = [
    ServiceTypeEnum.ORGAN,
    ServiceTypeEnum.SPECIMEN,
    ServiceTypeEnum.TEAM,
    ServiceTypeEnum.HAND_CARRY,
  ];

  return allowedTypes.some((type) => type === serviceType);
};

export const canGenerateTemplate = (userRole: UserRoleEnum | string): boolean => {
  const allowedRoles: UserRoleEnum[] = [UserRoleEnum.COORDINATOR, UserRoleEnum.MANAGEMENT, UserRoleEnum.EXECUTIVE_ADMIN];

  return allowedRoles.some((item) => item === userRole);
};
